export default "__VITE_ASSET__Do_Hrasp__"